<script lang="ts">
import FichePreference from '@/generated/fiches/FichePreference.vue';
import { Extended } from '@/framework/base/classes/Schema';
import { storeSession } from '@/generated/stores';
import { defineComponent } from "vue";

export default defineComponent({
  components: {},
  extends: FichePreference,
  methods: {
    isDisplayed(value: string): boolean {
      const test = storeSession.connectedUser;
      if ((!this.user || this.user.id < 0) && value == 'MODE_CONNEXION') {
        this.setExtended(new Extended('MODE_CONNEXION', this.fiche, true));
      }
      if (value == 'PASSWORD') {
        return this.user.connectionMode == 2;
      }
      return true;
    }
  }
})

</script>
